import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useProductMappingStore } from "./store";
import { useMedicinesStore } from "modules/medicines/store";
import { Button, Form, Input, Row, Select, Switch } from "antd";
import { isEmpty } from "lodash";

function AddNewProduct({ modalProductShow, setModalProductShow }) {
  const [form] = Form.useForm();
  const { setToaster } = useToast();
  const { medicinesData, medicinesLoading, fetchMedicinesData } =
    useMedicinesStore();
  const { fetchProductsData, addOneProductData } = useProductMappingStore();
  const [medicinesToShow, setMedicinesToShow] = useState([]);

  useEffect(() => {
    fetchMedicinesData();
  }, []);

  const handleModalClose = () => {
    form.resetFields();
    setModalProductShow(false);
  };

  const onSubmit = async (data) => {
    addOneProductData(data, setToaster, fetchProductsData, handleModalClose);
  };

  useEffect(() => {
    if (isEmpty(medicinesData)) setMedicinesToShow([]);
    else {
      const filteredMedicines = medicinesData?.filter((med) =>
        isEmpty(med.group)
      );
      setMedicinesToShow([...filteredMedicines]);
    }
  }, [medicinesData]);
  return (
    <Modal
      show={modalProductShow}
      onHide={() => setModalProductShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Product Mapping
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form
            form={form}
            layout="vertical"
            name="product_mapping"
            onFinish={onSubmit}
          >
            <Form.Item
              label="Product ID"
              name="productId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Medicine"
              name="medicineId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Select showSearch optionFilterProp="children">
                {!isEmpty(medicinesToShow) &&
                  medicinesToShow.map((medicine) => (
                    <Option value={medicine.id} key={medicine.id}>
                      {medicine.display_name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Product Principal ID"
              name="principalId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Direct Shipping" name="isDirectShipping">
              <Switch
                checkedChildren="Yes"
                defaultChecked={false}
                unCheckedChildren="No"
              />
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Create Product Mapping
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalProductShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddNewProduct;
